import {useEffect, useState} from "react";
import * as React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {IconButton, Stack, Typography} from "@mui/material";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import PreviousNextButton from "../../../../../components/PreviousNextButton";
import FormFieldText from "../../../../../components/FormFieldText";
import SearchIconButton from "../../../../../components/buttons/SearchIconButton";
import StringUtils from "../../../../../utils/StringUtils";
import FormFieldDate from "../../../../../components/FormFieldDate";
import dayjs from "dayjs";
import {Formats} from "../../../../../constants/Formats";
import FormFieldSelect from "../../../../../components/FormFieldSelect";
import {VisitorDriveType} from "../../../../../modules/vms/enums/VisitorDriveType";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import {ValidateUtils} from "../../../../../utils/ValidateUtils";
import {VisitRequestApi} from "../../../../../modules/vms/api/VisitRequestApi";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {MessageUtils} from "../../../../../utils/MessageUtils";
import LoadingBackdrop from "../../../../../components/LoadingBackdrop";
import {useNavigate} from "react-router-dom";
import {RoutePath} from "../../../../../constants/RoutePath";
import {IdTypes} from "../../../../../modules/vms/enums/IdTypes";

export type RegisterFinishFormProps = {
    visitRequest: VisitRequestDto;
    requestVisitor: RequestVisitorDto;
    onPrevious: () => void;
    fromEmployeeRegisterFlg?:boolean;
};

const RegisterFinishForm: React.FC<RegisterFinishFormProps> = (props) => {
    const intl = useIntl();

    const navigate = useNavigate();

    const [messageMap, setMessageMap] = useState(new Map<string, string>());
    const [loading, setLoading] = useState(false);

    const _handlePrevious = () => {
        props.onPrevious();
    }

    const _handleSubmit = async () => {
        if (!validate()) {
            return;
        }
        setLoading(true);
        const carryGoodsMap = {
            transportGoods: props.visitRequest.transportGoods,
            personalGoodsFlag: props.visitRequest.personalGoodsFlag,
            personalGoodsDescription: props.visitRequest.personalGoodsDescription
        };
        props.visitRequest.visitors = [];
        props.requestVisitor.carryGoods = JSON.stringify(carryGoodsMap);
        props.visitRequest.visitors.push(props.requestVisitor);
        const responseResult = await VisitRequestApi.registerVisitRequest(props.visitRequest);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'VMS_VISIT_REQUEST_REGISTER_SUCCESS'}));
            navigate(RoutePath.VMS_MOBILE_WELCOME);
        }
        setLoading(false);
    }

    const validate = () => {
        const newMessageMap = new Map<string, string>();
        // if (props.visitRequest.hostMobile === '') {
        //     newMessageMap.set('hostMobile', intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_MOBILE_REQUIRED'}));
        // }
        if (props.visitRequest.hostFullName === '') {
            newMessageMap.set('hostName', intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_NAME_REQUIRED'}));
        }
        if (props.visitRequest.arriveStartDate === '') {
            newMessageMap.set('arriveStartDate', intl.formatMessage({id: 'VMS_VISIT_REQUEST_ARRIVE_START_DATE_REQUIRED'}));
        }
        if (props.visitRequest.purpose === '') {
            newMessageMap.set('purpose', intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE_REQUIRED'}));
        }

        if (props.requestVisitor.idNumber === '') {
            newMessageMap.set('idNumber', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ID_NUMBER_REQUIRED'}));
        }
        if (props.requestVisitor.lastName === '') {
            newMessageMap.set('lastName', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_LAST_NAME_REQUIRED'}));
        }
        if (props.requestVisitor.firstName === '') {
            newMessageMap.set('firstName', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_FIRST_NAME_REQUIRED'}));
        }
        if (props.requestVisitor.mobile === '') {
            newMessageMap.set('mobile', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE_REQUIRED'}));
        } else if (!ValidateUtils.isMobileNumber(props.requestVisitor.mobile)) {
            newMessageMap.set('mobile', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE_FORMAT_ERROR'}));
        }
        if (props.requestVisitor.company === '') {
            newMessageMap.set('company', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_COMPANY_REQUIRED'}));
        }

        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    const visitPlaces = props.visitRequest.places.map(p => p.areaName).join(',');
    return (
        <div>
            <LoadingBackdrop open={loading} onClick={() => setLoading(false)}/>

            <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}
                           required={true} errorText={messageMap.get("hostName")}
                           value={StringUtils.maskName(props.visitRequest.hostFullName)}
                           disabled={true}/>
            <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_DEPARTMENT"})}
                           required={true} errorText={messageMap.get("hostDepartmentName")}
                           value={props.visitRequest.hostDepartmentName}
                           disabled={true}/>
            <FormFieldDate label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_DATE"})}
                           required={true} errorText={messageMap.get("arriveStartDate")}
                           value={dayjs(props.visitRequest.arriveStartDate, Formats.DATE_SIMPLE)}
                           disabled={true}/>
            <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PURPOSE"})}
                           required={true} errorText={messageMap.get("purpose")}
                           value={props.visitRequest.purpose}
                           disabled={true}/>
            {props.fromEmployeeRegisterFlg?
                <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_EMPLOYEE_NO"})}
                                                          value={props.requestVisitor.remarks}
                                                          disabled={true}/>
                                                          :null}
            <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_ID_TYPE"})}
                           value={intl.formatMessage({id: IdTypes.Map.get(props.requestVisitor.idType)})}
                           disabled={true}/>
            <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_ID_NUMBER"})}
                           required={true} errorText={messageMap.get("idNumber")}
                           value={props.requestVisitor.idNumber}
                           disabled={true}/>
            <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_MOBILE"})}
                           required={true} errorText={messageMap.get("mobile")}
                           value={props.requestVisitor.mobile}
                           disabled={true}/>
            <Stack direction={'row'}>
                <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_LAST_NAME"})}
                               required={true} errorText={messageMap.get("lastName")}
                               value={props.requestVisitor.lastName}
                               disabled={true}/>
                <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_FIRST_NAME"})}
                               required={true} errorText={messageMap.get("firstName")}
                               value={props.requestVisitor.firstName}
                               disabled={true}/>
            </Stack>
            <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY"})}
                           required={true} errorText={messageMap.get("company")}
                           value={props.requestVisitor.company}
                           disabled={true}/>
            <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_DRIVE_TYPE"})}
                           value={intl.formatMessage({id: VisitorDriveType.Map.get(props.requestVisitor.driveType)})}
                           disabled={true}/>
            <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER"})}
                           disabled={true}
                           value={props.requestVisitor.plateNumber}/>
            <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_TRANSPORT_GOODS"})}
                           disabled={true}
                           value={props.visitRequest.transportGoods}/>
            <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PERSONAL_GOODS_DESCRIPTION"})}
                           disabled={true}
                           value={props.visitRequest.personalGoodsDescription}/>
            <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PLACE"})}
                           disabled={true}
                           value={visitPlaces}/>
            <PreviousNextButton onPrevious={_handlePrevious}
                                nextText={intl.formatMessage({id: 'COMMON_SUBMIT'})}
                                onNext={_handleSubmit}/>
        </div>
    )
};

export default RegisterFinishForm;